import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { API_BASE_URL as BASE_URL } from '@/environments/environment';

export interface CustomerCouponAvailability {
  isAvailable: boolean;
  couponId: string;
  sellerStoreId: string;
  code: string;
  discountType: 'Percentage' | 'FixedAmount';
  discountValue: number;
  discountValueCurrency: string | null;
  minimumSpend: number | null;
  maximumSpend: number | null;
  startsAtUtc: string | null;
  expiresAtUtc: string | null;
  title: string;
}

export interface SellerCouponSelection {
  sellerStoreId: string;
  sellerSubtotal: number;
  currentSelectedCouponId: string | null;
  currentSelectedCouponCode: string | null;
}

export interface AvailableCouponsRequest {
  sellerSelections: SellerCouponSelection[];
  checkedAtUtc?: string;
}

export interface AvailableCouponsResponse {
  sellers: {
    sellerStoreId: string;
    coupons: CustomerCouponAvailability[];
  }[];
}

export interface ValidateCouponRequest {
  sellerStoreId: string;
  sellerSubtotal: number;
  code: string;
  currentSelectedCouponId: string | null;
  currentSelectedCouponCode: string | null;
  checkedAtUtc?: string;
}

@Injectable({
  providedIn: 'root',
})
export class CustomerCouponsApi {
  constructor(private readonly http: HttpClient) {}

  /**
   * List available coupons for multiple sellers
   * POST /api/v{version}/coupons/available
   */
  listAvailableCoupons(request: AvailableCouponsRequest) {
    return this.http.post<AvailableCouponsResponse>(
      BASE_URL + '/api/v1/coupons/available',
      request,
    );
  }

  /**
   * Validate a manually entered coupon code for a specific seller
   * POST /api/v{version}/coupons/validate
   */
  validateCoupon(request: ValidateCouponRequest) {
    return this.http.post<CustomerCouponAvailability>(
      BASE_URL + '/api/v1/coupons/validate',
      request,
    );
  }
}
